module.exports = __webpack_public_path__ + "media/images/app/visitors/couture/hero_mobile-8df3ddc57ea5efd193768b5d218c6419.webp";